module.exports = "\n<div id=\"{{game._id ? game._id:game.id}}-middlesmall\" style=\"margin-bottom: 5px;\" _v-6356f3a3=\"\">\n  <div id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:60px;\" :class=\"classboard\" _v-6356f3a3=\"\">\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6356f3a3!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/game/boardVisorSmall.vue
// module id = 536
// module chunks = 11